/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_4Inputs */



/**
* | output |
* | --- |
* | "Basic subtitle file export (excluding SCC, MCC, and EBU STL)" |
*
* @param {Signup_Feature_Starter_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_4 = /** @type {((inputs?: Signup_Feature_Starter_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
	return /** @type {LocalizedString} */ ("Basic subtitle file export (excluding SCC, MCC, and EBU STL)")
});